import React from 'react';
import './Theme.css';
import './Resume.css';

const Resume = () => {
  return (
    <section className="resume-page">
      <h1>My Resume</h1>


      <div className="resume-pdf-container">
        <iframe
          src="/resume.html"
          title="Garrett Albracht's Resume"
          className="resume-pdf"
        />
      </div>

      <div className="resume-actions">
        <a
          href="/Garrett_Albracht_Data_Engineer_Resume.pdf"
          download="Garrett_Albracht_Data_Engineer_Resume.pdf"
          className="resume-button"
        >
          Download PDF
        </a>
        <a
          href="/Garrett_Albracht_Data_Engineer_Resume.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="resume-button resume-button--secondary"
        >
          Open in new tab
        </a>
      </div>
    </section>
  );
};

export default Resume;
